<template>
  <div class="module_page advisee_tracker db_adv_v1" aria-label="Advisee tracker detail page">
    <div class="row dashboard-row stream-section" v-if="!showLoader">
      <div class="col-md-12 col-sm-12 advisee_sec" :class="namedQueriesEnabled? 'col-xl-12 col-lg-12 named_query_enabled': 'col-xl-8 col-lg-7 named_queries_disabled'">
        <div class="advisee_sec_crd">
          <div class="row">
            <div class="col-12">
              <div class="page-heading">
                <div class="row">
                  <template v-if="false" :class="isInstructorDashboard ? 'inst_dashboard_nav':''">
                    <div class="col-xl-6 col-lg-5 col-md-12 col-sm-12 input module_heading" role="heading" aria-level="1">
                      <div class="module_icon ic9-student"></div>
                      <label
                        v-if="isProspectiveStudent"
                        id="catalogTitle"
                        class="head_txt module_type_name ml-1 ace_sec_hd"
                        role="heading"
                        aria-label="$t('prospectiveStudentTrackerAria')">
                          {{ $t('prospectiveStudentTracker') }}
                      </label>
                      <label
                        v-if="!isProspectiveStudent && namedQueriesEnabled"
                        id="catalogTitle"
                        class="head_txt module_type_name ml-1 ace_sec_hd"
                        role="heading"
                        aria-label="$t('adviseeTrackerAria')">
                          {{ groupToShow.name }}
                        </label>
                      <label
                        v-if="!isProspectiveStudent && !namedQueriesEnabled"
                        id="catalogTitle"
                        class="head_txt module_type_name ml-1 ace_sec_hd"
                        role="heading"
                        aria-label="$t('adviseeTrackerAria')">
                          {{ $t('adviseeTracker') }}
                      </label>
                    </div>
                    <div class="col-xl-6 col-lg-7 col-md-12 col-sm-6 search_field advisor-search-section">
                      <input
                        :placeholder="$t('searchByNamePH')"
                        :aria-label="$t('searchByNameAria')"
                        v-model="name"
                        v-on:keyup.enter="searchAdvisees">
                      <b-btn
                        class="left"
                        @click="searchAdvisees">
                          <span
                            class="fas fa-search"
                            aria-label="$t('searchAdvisee')">
                          </span>
                      </b-btn>
                      <!--
                      <div class="clear-btn" v-if="this.name.length > 0" @click="searchAdvisees">
                        <b-btn class="left" @click="name = ''">X</b-btn>
                      </div>
                      -->
                      <span class="more-link" style="margin-top: 5px;">
                        <b-link
                          :to="{name: 'adviseeTracker'}"
                          class="ace_sec_txt mr-3 hd_lnk"
                          :aria-label="goToAdviseeTrackerAria"
                          :title="goToAdviseeTrackerTitle">
                            {{ $t('more') }}
                        </b-link>
                      </span>
                    </div>
                    <!--
                    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 btn-container">
                      <button type="button"
                        class="btn btn_trans"
                        @click="clickPrev()"
                        :disabled="!showPrev"
                        v-b-tooltip.hover :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                      <button
                        class="page_count btn"
                        aria-label="page number">
                          {{ page + 1 }}
                        </button>
                      <button type="button"
                        class="btn next btn_trans"
                        @click="clickNext()"
                        :disabled="!showNext"
                        v-b-tooltip.hover :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                      <div
                        class="out-of-total-item"
                        :aria-label="start + ' ' + end + ' of ' + total"
                        tabindex="0">
                          {{start}}-{{end}} of {{total}}
                      </div>
                    </div>
                    -->
                  </template>
                  <template v-if="true">
                    <div v-show="selectedUserUuids.length > 0">
                      <div class="action_top_menu">
                        <channel-calendar-note-action-menu ref="group-action-menu" :action="'sendGroupMessage'" :user-ids="selectedUserUuids" :sender-id="userObj.userId" :active="true" :isProspectiveStudent="isSelectedUuidContainProspectiveStudent"></channel-calendar-note-action-menu>
                      </div>
                      <div class="selected_msg_bx">
                        <span v-if="selectedItemMessage && selectedItemMessage.length>5"> {{selectedItemMessage}}</span>
                      </div>
                    </div>
                    <div class="module_heading" role="heading" aria-level="1">
                      <div class="select_all_checkbox">
                        <input id="selectAllCheckbox"
                          ref="selectcurrentPageCheckbox"
                          type=checkbox
                          @click="selectPage()"
                          v-model="pageSelected"
                          aria-label="click on spacebar key to select all users"
                        />
                        <label for="selectAllCheckbox" class="visibility_hide">click on spacebar key to select all users</label>
                      </div>
                      <div class="module_icon ic-Student"></div>
                      <label
                        id="catalogTitle"
                        class="head_txt module_type_name ml-1 ace_sec_hd"
                        role="heading"
                        :aria-label="$t('prospectiveStudentTrackerAria')"
                        v-if="isProspectiveStudent">
                          {{ $t('prospectiveStudentTracker') }}
                      </label>
                      <label
                        id="catalogTitle"
                        class="head_txt module_type_name ace_sec_hd"
                        role="heading"
                        :aria-label="$t('adviseeTrackerAria')"
                        v-if="!isProspectiveStudent && namedQueriesEnabled">
                          <b-form-select
                            v-model="currentGroup"
                            :options="groups"
                            class=""
                            value-field="name"
                            text-field="name"
                            disabled-field="notEnabled"
                            :title="currentGroup + ' (' + groupToShow.length + ')'">
                          </b-form-select>
                        <span class="hd_txt_inner">
                          <span class="val">{{currentGroup}}</span>
                          <!--
                          <span class="count">({{groupToShow.length}})</span>
                          -->
                          <span class="count">({{rangeValue()}})</span>
                          <span class="ic9-dropdown2" aria-hidden="true"></span>
                        </span>
                      </label>
                      <label
                        id="catalogTitle"
                        class="head_txt module_type_name ml-1 ace_sec_hd"
                        role="heading"
                        :aria-label="$t('adviseeTrackerAria')"
                        v-if="!isProspectiveStudent && !namedQueriesEnabled">
                          {{ $t('adviseeTracker') }}
                      </label>
                    </div>
                    <div class="toolbar-right advisor-search-section ui-list-toolbar">
                      <template v-if="!namedQueriesEnabled">
                        <div class="out-of-total-item ace_sec_txt" tabindex="0">{{start}}-{{end}} of {{total}}</div>
                        <div class="btn_container pagination_sty3">
                          <button type="button" class="btn btn_trans" @click="clickPrev()" :disabled="!showPrev" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                          <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                          <button type="button" class="btn next btn_trans"  @click="clickNext()" :disabled="!showNext" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                        </div>
                        <div class="search-box-container">
                          <input type="text" class="input-search" placeholder="type to narrow results" aria-label="type to narrow results" v-model="name" v-on:keyup.enter="searchAdvisees">
                          <button type="button" class="btn btn_srh" @click="searchAdvisees" aria-label="search advisee">
                            <span class="ic_srh ic_search" aria-hidden="true"></span>
                          </button>
                        </div>
                      </template>
                      <template v-if="namedQueriesEnabled">
                        <div class="btn_container pagination_sty3">
                          <button type="button"
                            :disabled="firstPage"
                            v-on:click="prev"
                            class="btn btn_trans"
                            v-b-tooltip.hover :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                          <span
                            class="page_count"
                            aria-hidden="true">
                            {{ currentPage }}
                          </span>
                          <button type="button"
                            :disabled="lastPage"
                            v-on:click="next"
                            class="btn btn_trans"
                            v-b-tooltip.hover :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                        </div>
                        <div class="search-box-container">
                          <input
                            type="text"
                            class="input-search"
                            :placeholder="$t('typeToNarrowResults')"
                            :aria-label="$t('typeToNarrowResults')"
                            v-model="searchQuery">
                          <button type="button" class="btn btn_srh" :aria-label="$t('typeToNarrowResults')">
                            <span class="ic_srh ic_search" aria-hidden="true"></span>
                          </button>
                        </div>
                        <template v-if="showExportNamedQuery">
                          <button
                            class="btn_export"
                            tabindex="0"
                            @click="exportProspectiveStudents()"
                            :title="$t('exportAllProspectiveStudentsTitle')"
                            v-b-tooltip.hover>
                              {{ $t('export') }}
                          </button>
                        </template>
                        <template v-if="!showExportNamedQuery">
                          <button
                            class="btn_export"
                            tabindex="0"
                            @click="exportNamedQueryResults()"
                            :title="$t('exportAllResultsTitle')"
                            v-b-tooltip.hover>
                              {{ $t('export') }}
                          </button>
                        </template>
                        <div class="sec_sort_by">
                          <b-dropdown variant="link" no-caret toggle-class="sort-by ace_sec" class="pg_sec_menu">
                            <template slot="button-content" :aria-label="$t('sort')">
                              <span class="ic2_sort2 sort-by-icon" aria-hidden="true"></span>
                              <span class="txt_srt">{{ $t('sort') }}</span>
                            </template>
                            <div class="links_container">
                              <div class="links new_menu">
                                <b-dropdown-item
                                  active
                                  id="sortLinkAsc"
                                  class="lnk_menu"
                                  :aria-label="$t('ascendingAria')"
                                  @click="sortAsc">
                                  <span class="ic ic-sort-alpha-asc"></span>
                                  <span class="lnk_txt">
                                    {{ $t('ascending') }}
                                  </span>
                                </b-dropdown-item>
                                <b-dropdown-item
                                  id="sortLinkDes"
                                  class="lnk_menu"
                                  aria-label="$t('descending')"
                                  @click="sortDesc">
                                    <span class="ic ic-sort-alpha-desc"></span>
                                    <span class="lnk_txt">
                                      {{ $t('descending') }}
                                    </span>
                                </b-dropdown-item>
                              </div>
                            </div>
                          </b-dropdown>
                          <a v-if="isInstructorDashboard" href="javascript:void(0)" class="hd_lnk" @click="goToFullScreen()">
                            <span class="ic ic-fullscreen" title="enter full screen"></span>
                          </a>
                        </div>
                      </template>
                    </div>

                  </template>
                </div>

              </div>

              <div class="selected_tags_container filter-tags-wrapper" v-if="namedQueriesEnabled && selectedTags.length > 0">
                <div
                  class="search_tag filter-tag"
                  v-for="(tag, index) in selectedTags"
                  :key="'advisee-tag-' + index"
                  @blur="getTagContainerRowWidth(index)"
                  :aria-label="tag + '. tag'"
                  tabindex="0"
                >
                  <span class="title" :title="tag">{{ tag }}</span>
                  <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeFromSelectedTags(tag)">
                  </span>
                </div>
              </div>

            </div>
          </div>
          <div class="advisor-detail-container pg_list">
            <div id="userDetailsPopover" class="user-detail-popover"></div>
            <div v-if="namedQueriesEnabled">
              <div v-for="(advisee, index) in groupToShow" :key="advisee.userId" >
                <div class="row list_row lst_pg__row ace_sec" @mouseover.stop="mouseOver(advisee)" @mouseleave.stop="mouseLeave(advisee)" @focus="mouseOver(advisee)" v-if="(index<pageSize*currentPage && index>=pageSize*(currentPage-1))" :class="advisee.suspended ? 'suspended':''" :title="advisee.suspended ? 'user suspended':''" v-b-tooltip.hover>

                  <div class="col-11 row_data">
                    <div class="row">
                      <div class="col-xl-4 col-lg-5 col-md-12 col-sm-12">
                        <div class="row">
                          <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col_chkbx">
                            <b-form-checkbox
                              plain
                              :value="{'userUuid': advisee.userId, 'role': advisee.userRole}"
                              v-model="selectedUserUuids"
                              :aria-label="'click on spacebar key to select ' + advisee.userName"
                              >
                              <span class="visibility_hide">click on spacebar key to select {{advisee.userName}} </span>
                            </b-form-checkbox>
                          </div>

                          <div class="col-xl-1 col-lg-2 col-md-1 col-sm-1 usr_pic" :id="advisee.userExternalId" tabindex="0">
                            <template v-if="advisee.suspended">
                              <span class="icon ic9-student usr_suspended"></span>
                            </template>
                            <template v-else>
                              <template v-if="!isCustomAdvisor()">
                                <template v-if="isDisableLearnerHome()">
                                    <span class="icon ic9-student">
                                      <span class="visibility_hide"> {{advisee.userName}} </span>
                                    </span>
                                </template>
                                <template v-else>
                                  <b-link v-if="advisee.userRole !== 'Prospective Student'" :to="{name: 'learnerHomePage', params: {uuid: advisee.userId, isInstructorAdvisor: isInstructorDashboard}}">
                                    <span class="icon ic9-student">
                                      <span class="visibility_hide"> {{advisee.userName}} </span>
                                    </span>
                                  </b-link>
                                </template>
                              </template>
                              <template v-else>
                                <template v-if="!customAdvisorLearnerHome()">
                                    <span class="icon ic9-student">
                                      <span class="visibility_hide"> {{advisee.userName}} </span>
                                    </span>
                                </template>
                                <template v-else>
                                  <b-link v-if="advisee.userRole !== 'Prospective Student'" :to="{name: 'learnerHomePage', params: {uuid: advisee.userId, isInstructorAdvisor: isInstructorDashboard}}">
                                    <span class="icon ic9-student">
                                      <span class="visibility_hide"> {{advisee.userName}} </span>
                                    </span>
                                  </b-link>
                                </template>
                              </template>

                              <template v-if="advisee.userRole === 'Prospective Student'">
                                <b-link :to="{ name: 'userActivityReport', params: { uuid: 'abc', userId: advisee.userId }}">
                                  <span class="icon ic9-student">
                                    <span class="visibility_hide"> {{advisee.userName}} </span>
                                  </span>
                                </b-link>
                              </template>
                            </template>
                          </div>

                          <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 usr_data">
                            <div class="row block">

                              <div class="col-12 block_row block_tp_row">
                                <template v-if="!isCustomAdvisor()">
                                  <template v-if="isDisableLearnerHome()">
                                    <span class="user_name ace_sec_hd" role="heading" :aria-label="advisee.userName">{{advisee.userName}}</span>
                                  </template>
                                  <template v-else>
                                  <b-link v-if="advisee.userRole !== 'Prospective Student'" :to="{name: 'learnerHomePage', params: {uuid: advisee.userId, isInstructorAdvisor: isInstructorDashboard}}">
                                    <span class="user_name ace_sec_hd" role="heading" :aria-label="advisee.userName">{{advisee.userName}}</span>
                                  </b-link>
                                  </template>
                                </template>
                                <template v-else>
                                  <template v-if="!customAdvisorLearnerHome()">
                                    <span class="user_name ace_sec_hd" role="heading" :aria-label="advisee.userName">{{advisee.userName}}</span>
                                  </template>
                                  <template v-else>
                                  <b-link v-if="advisee.userRole !== 'Prospective Student'" :to="{name: 'learnerHomePage', params: {uuid: advisee.userId, isInstructorAdvisor: isInstructorDashboard}}">
                                    <span class="user_name ace_sec_hd" role="heading" :aria-label="advisee.userName">{{advisee.userName}}</span>
                                  </b-link>
                                  </template>

                                </template>

                                <template v-if="advisee.userRole === 'Prospective Student'">
                                  <b-link :to="{ name: 'userActivityReport', params: { uuid: 'abc', userId: advisee.userId }}">
                                    <span class="user_name ace_sec_hd" role="heading" :aria-label="advisee.userName">{{advisee.userName}}</span>
                                  </b-link>
                                </template>
                              </div>
                              <!--
                              <div class="col-12 block_row external_id" :aria-label="'External Id ' + advisee.userExternalId" v-if="advisee.suspended">
                                <div class="block_val" style="font-size: 16px;">Suspended</div>
                              </div>
                              -->

                              <div class="col-12 block_row external_id" :aria-label="'External Id ' + advisee.userExternalId" v-if="isShowStudentExternalId">
                                <div class="block_label">External Id: </div>
                                <div class="block_val" style="font-size: 16px;">{{advisee.userExternalId}}</div>
                              </div>

                              <div class="col-12 block_row email_row" v-if="isShowStudentEmail">
                                <div class="ic_container">
                                  <span class="ic ic9-email"></span>
                                </div>
                                <span class="block_val user_email ace_sec_txt" :aria-label="advisee.userEmail">{{advisee.userEmail}}</span>
                              </div>

                              <!--
                              <div class="block additional_info col-xl-5 col-lg-12 col-md-12 col-sm-12" style="padding-right: 0px;">
                                <div class="row">
                                  <div class="icon_container col-xl-12 col-lg-4 col-md-12 col-sm-12" v-if="!isProspectiveStudent" style="padding-left: 0px;">
                                    <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                                      <template v-if="redirectStreamToProgressView">
                                        <b-link class="view_plan btn" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamProgress', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                                          <span class="icon-stream"></span>
                                          <span class="title">view plan</span>
                                        </b-link>
                                      </template>
                                      <template v-else>
                                        <b-link class="view_plan btn" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamPlanner', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                                          <span class="icon-stream"></span>
                                          <span class="title">view plan</span>
                                        </b-link>
                                      </template>
                                      <template v-if="isLockStreamEnabled">
                                        <b-link class="access_plan" v-if="isLocked(advisee.adviseeSharedStreams[0])" @click.stop.prevent="unlockStreamClicked(advisee.adviseeSharedStreams[0])">
                                          <span class="ic ico-lock" style="margin-top: -5px;"></span>
                                          <span class="title">Locked</span>
                                        </b-link>
                                        <b-link class="access_plan" v-else @click.stop.prevent="lockStreamClicked(advisee.adviseeSharedStreams[0])">
                                          <span class="ic ico-unlock"></span>
                                          <span class="title">Unlocked</span>
                                        </b-link>
                                      </template>
                                    </template>
                                    <template v-else>
                                      <template v-if="!isAutomaticStreamShareTurnedOn">
                                        <b-link class="view_plan"
                                        <span class="icon-stream"></span>
                                        <span class="title" style="cursor: pointer;" @click="requestAccessToPlanningStream(advisee)">Request Access</span>
                                        </b-link>
                                      </template>
                                    </template>
                                  </div>
                                  <div class="block_row ace_sec_txt col-xl-12 col-lg-8 col-md-12 col-sm-12" style="margin-top: 2px; padding-right: 0px; height: auto;" v-if="isCocuricularVerificationFeature">
                                    <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].coCurricularStatusMap">
                                      <template v-if="advisee.adviseeSharedStreams[0].coCurricularStatusMap.total > 0">
                                        <span style="font-size: 14px;">Co-curricular Verification Requests:</span> <br/>
                                        <span>Total - {{advisee.adviseeSharedStreams[0].coCurricularStatusMap.total}}</span> /
                                        <span style="cursor: pointer; color: #157099;" @click="goToTimeView(advisee.adviseeSharedStreams[0].uuid)">Pending - {{advisee.adviseeSharedStreams[0].coCurricularStatusMap.pending}}</span>
                                      </template>
                                      <template v-else>
                                        <span style="font-size: 14px;">Co-curricular Verification Requests:</span> <br/>
                                        <span>Total - 0</span> /
                                        <span style="cursor: pointer; color: #157099;" @click="goToTimeView(advisee.adviseeSharedStreams[0].uuid)">Pending - 0</span>
                                      </template>
                                    </template>
                                  </div>
                                </div>

                              </div>
                              -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-8 col-lg-7 col-md-12 col-sm-12 additional_info">
                        <div class="row">
                          <div class="col-6">
                            <div class="row">
                              {{isShowProgramName.length}}
                              <template v-if="isShowProgramName">
                                <div class="col-12 block_row program" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].majorTitle && advisee.adviseeSharedStreams[0].majorTitle.length > 0">
                                  <!--<div class="block_label" tabindex="0">{{majorLabel}}: </div>-->
                                  <div class="ic_container">
                                    <span class="ic ic8-degree"></span>
                                  </div>
                                  <div class="block_val">
                                    {{advisee.adviseeSharedStreams[0].majorTitle}}
                                  </div>
                                </div>
                                <div class="col-12 block_row program" v-else>
                                  <!--<div class="block_label" tabindex="0">{{majorLabel}}: </div>-->
                                  <div class="ic_container">
                                    <span class="ic ic8-degree"></span>
                                  </div>
                                  <div class="block_val">Undecided</div>
                                </div>
                              </template>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="row">
                              <template v-if="isShowCareerInterest">
                                <div class="col-12 block_row program" v-if="advisee.careerGoal">
                                  <!--<div class="block_label" tabindex="0">{{majorLabel}}: </div>-->
                                  <div class="ic_container">
                                    <span class="ic ico-career"></span>
                                  </div>
                                  <div class="block_val">{{advisee.careerGoal}}</div>
                                </div>
                                <div class="col-12 block_row program" v-else>
                                  <!--<div class="block_label" tabindex="0">{{majorLabel}}: </div>-->
                                  <div class="ic_container">
                                    <span class="ic ico-career"></span>
                                  </div>
                                  <div class="block_val">Undecided</div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="isShowNamedQueryInformation">
                          <template v-for="key in namedQueryToShow.headers">
                            <div class="col-6" style="padding-bottom: 4px;">
                              <div class="row">
                                <div class="col-12 block_row program">

                                  <div class="ic_container" v-if="(key==='Job Title')">
                                    <span class="ic ico-career"></span>
                                  </div>
                                  <div class="ic_container" v-else>
                                    <span class="ic" style="width: 30px; float: left;">&nbsp;</span>
                                  </div>

                                  <div  class="block_val" v-if="(key==='Course')" >
                                    <template v-if="(advisee.namedQueryInfoMap[namedQueryToShow.name+'_courseId']) && allowViewCourseReport">
                                      {{key}}: <a href="javascript://" class="ace_sec" @click="openLearnerCourseReportModal(advisee, advisee.namedQueryInfoMap[namedQueryToShow.name+'_courseId'])" >{{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key])}}</a>
                                    </template>
                                    <template v-else>
                                      {{key}}: {{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key])}}
                                    </template>
                                  </div>
                                  <div  class="block_val" v-else-if="(key==='Program')" >
                                    <template v-if="(advisee.namedQueryInfoMap[namedQueryToShow.name+'_programCode'])">
                                      {{key}}: <a href="javascript://" class="ace_sec" @click="openAcademicProgressModal(advisee, advisee.namedQueryInfoMap[namedQueryToShow.name+'_programCode'], advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key])" >{{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key])}}</a>
                                    </template>
                                    <template v-else>
                                      {{key}}: {{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key])}}
                                    </template>
                                  </div>
                                  <div class="block_val" v-else-if="(key==='Time Taken')">
                                    {{key}}: {{getHumandReadableTimeTaken(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key])}}
                                  </div>
                                  <div class="block_val" v-else-if="(key==='Phone')">
                                    {{key}}: {{advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key]}}
                                  </div>

                                  <div class="block_val" v-else>
                                    {{key}}: {{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key])}}
                                  </div>

                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                          <template>
                            <template v-for="index in 20">
                                <div class="row" >
                                <template v-for="key in namedQueryToShow.headers">
                                  <div class="col-6" style="padding-bottom: 4px;" v-if="advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index]">
                                    <div class="row">
                                      <div class="col-12 block_row program">

                                        <div class="ic_container" v-if="(key==='Job Title')">
                                          <span class="ic ico-career"></span>
                                        </div>

                                        <div class="ic_container" v-else>
                                          <span class="ic" style="width: 30px; float: left;">&nbsp;</span>
                                        </div>
                                        <div v-if="(key!=='Course' && key!=='Program' && key!=='Time Taken')" class="block_val">
                                          {{key}}: {{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index])}}
                                        </div>
                                        <div  class="block_val" v-else-if="(key==='Course')">
                                          <template v-if="(advisee.namedQueryInfoMap[namedQueryToShow.name+'_courseId'+index]) && allowViewCourseReport">
                                            {{key}}: <a href="javascript://" class="ace_sec" @click="openLearnerCourseReportModal(advisee, advisee.namedQueryInfoMap[namedQueryToShow.name+'_courseId'+index])" >{{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index])}}</a>
                                          </template>
                                          <template v-else>
                                            {{key}}: {{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index])}}
                                          </template>
                                        </div>
                                        <div  class="block_val" v-else-if="(key==='Time Taken')">
                                            {{key}}: {{getHumandReadableTimeTaken(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index])}}
                                        </div>
                                        <div  class="block_val" v-else-if="(key==='Program')">
                                          <template v-if="(advisee.namedQueryInfoMap[namedQueryToShow.name+'_programCode'+index])">
                                            {{key}}: <a href="javascript://" class="ace_sec" @click="openAcademicProgressModal(advisee, advisee.namedQueryInfoMap[namedQueryToShow.name+'_programCode'+index],advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index])" >{{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index])}}</a>
                                          </template>
                                          <template v-else>
                                            {{key}}: {{getHumandReadableTime(advisee.namedQueryInfoMap[namedQueryToShow.name+'_'+key+index])}}
                                          </template>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                                </div>
                            </template>
                          </template>

                        <div class="row" v-if="advisee.userRole === 'Prospective Student'">
                          <div class="col-6" style="padding-bottom: 4px;">
                            <div class="row">
                              <div class="col-12 block_row program">

                                <div class="ic_container">
                                  <span class="ic" style="width: 30px; float: left;">&nbsp;</span>
                                </div>

                                <div class="block_val">Inquiry Date: {{advisee.startDate}}</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6" style="padding-bottom: 4px;">
                            <div class="row">
                              <div class="col-12 block_row program">

                                <div class="ic_container">
                                  <span class="ic" style="width: 30px; float: left;">&nbsp;</span>
                                </div>

                                <div class="block_val">Status: {{advisee.userStatus}}</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="advisee.userRole === 'Prospective Student'">

                        </div>

                        <div class="row">
                          <div class="col-12">
                            <template v-if="areTagsReadyComputed">
                              <div class="tags_container_row" :id="'tagsRow_' + index">
                                <div class="ic-tag"></div>
                                <div class="applied_tags" :id="'tagsContainer_' + index">
                                  <template v-if="getUserTags(advisee.userId).length > 0">
                                    <span @click="addToSelectedTags(tag)" class="tag" v-for="tag in getUserTags(advisee.userId).slice(0, 3)" :aria-label="tag + '. tag'" tabindex="0" v-if="">
                                      <span class="tag_name" :title="tag">{{tag}}</span>
                                    </span>
                                  </template>
                                  <template v-else>
                                    <span class="no_tag">no tag added</span>
                                  </template>
                                </div>
                                <template v-if="getUserTags(advisee.userId).length > 3">
                                  <div class="show_more_tags active">
                                    <b-dropdown variant="link" no-caret class="all_tags_list">
                                      <template slot="button-content">
                                        <span class="btn_more">...</span>
                                      </template>
                                      <div class="links_container">
                                        <div class="links">
                                          <span class="tag" @click="addToSelectedTags(tag)" v-for="tag in getUserTags(advisee.userId)">
                                            <span class="tag_name">{{tag}}</span>
                                          </span>
                                        </div>
                                      </div>
                                    </b-dropdown>
                                  </div>
                                </template>

                              </div>
                            </template>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>


                  <div class="col-1 action_menu_container">
                    <div class="action">
                      <channel-calendar-note-action-menu :ref="'action-menu-' + advisee.userId" :action="'view'" :user-ids="[{userUuid: advisee.userId}]" :sender-id="userObj.userId" :active="false" :isProspectiveStudent="advisee.userRole === 'Prospective Student'" :changeProgram="getChangeProgram(advisee)"></channel-calendar-note-action-menu>
                    </div>
                    <div class="custom_modal_v6">
                      <b-modal class="" :ref="'actAsUserModal_' + advisee.userId" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop hide-footer no-close-on-esc centered>
                          <div slot="modal-header" class="header-section">
                            <div class="ic_container">
                              <span class="ic ic24-mask"></span>
                            </div>
                            <div class="modal-title">Act As User {{advisee.userName}}</div>
                            <div class="btn_container">
                              <button type="button" class="btn_close" @click="closeActAsUserModal(advisee.userId)" aria-label="close">
                                <span class="ic-close"></span>
                              </button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 msg">
                              You will be now "logging" in as {{advisee.userName}} and you will be able to see what {{advisee.userName}} can see!
                            </div>
                            <div class="col-12 btn_container">
                              <b-btn @click.stop="actAsUser(advisee)" class="btn" aria-label="Act as User">switch</b-btn>
                            </div>
                          </div>
                      </b-modal>
                    </div>
                    <div class="custom_modal_v6">
                      <b-modal class="" :ref="'changeProgramrModal_' + advisee.userId" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop hide-footer no-close-on-esc centered>
                          <div slot="modal-header" class="header-section">
                            <div class="ic_container">
                              <span class="ic ic24-degreeProgram"></span>
                            </div>
                            <div class="modal-title">Change program for User {{advisee.userName}}</div>
                            <div class="btn_container">
                              <button type="button" class="btn_close" @click="closeChangeProgramModal(advisee.userId)" aria-label="close">
                                <span class="ic-close"></span>
                              </button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 msg">
                              You will be changing program for {{advisee.userName}}  to {{getChangeProgram(advisee)}}
                            </div>
                            <div class="col-12 btn_container">
                              <b-btn @click.stop="changeProgramForUser(advisee)" class="btn" aria-label="Act as User">continue</b-btn>
                            </div>
                          </div>
                      </b-modal>
                    </div>

                  </div>

                </div>


              </div>
              <!-- .row -->
            </div>
            <div v-if="!namedQueriesEnabled">
              <div v-for="advisee in advisees" :key="advisee.userId">
                <div class="row list_row lst_pg__row named_queries_disabled">
                  <div class="col-11 row_data">
                    <div class="row">

                      <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                        <div class="row">
                          <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col_chkbx">

                          </div>
                          <div class="col-xl-1 col-lg-2 col-md-1 col-sm-1 usr_pic" :id="advisee.userExternalId" tabindex="0">
                            <span class="icon ic6-user1"></span>
                          </div>
                          <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 usr_data">
                            <div class="row block">

                              <div class="col-12 block_row block_tp_row">
                                <span class="user_name ace_sec_hd" role="heading" :aria-label="advisee.userName">{{advisee.userName}}</span>

                                <b-popover ref="progressPopup" :target="advisee.userExternalId" triggers="hover" container="userDetailsPopover" v-if="showStudentPopover && advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                                  <template slot="title">
                                    <div class="header-title">
                                      <span class="icon icon-stream"></span>
                                      <span class="entity-title" tabindex="0">{{ advisee.userName }} </span>
                                    </div>
                                  </template>
                                  <div class="cont-section">
                                    <div class="left-col">
                                      <div class="icon-mentor"></div>
                                    </div>
                                    <div class="right-col">
                                      <div class="content-row">
                                        <span class="left-info" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Major: {{advisee.adviseeSharedStreams[0].majorTitle}}</span>
                                        <span class="left-info" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Major Credits Completed: {{advisee.adviseeSharedStreams[0].majorCompletedCredit}}</span>
                                        <span class="left-info" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Major GPA: {{advisee.adviseeSharedStreams[0].majorGPA}}</span>
                                        <span class="heading" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" tabindex="0">Overall Credits Completed: {{advisee.adviseeSharedStreams[0].overallCompletedCredit}}</span><br/>
                                        <span class="heading" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" style="margin-top: 8px; float: left;" tabindex="0">Overall GPA: {{advisee.adviseeSharedStreams[0].overallGPA}}</span>
                                      </div>
                                    </div>
                                  </div>
                                </b-popover>
                              </div>

                              <div class="col-12 block_row external_id" :aria-label="'External Id ' + advisee.userExternalId" v-if="isShowStudentExternalId">
                                <div class="block_label">External Id: </div>
                                <div class="block_val">{{advisee.userExternalId}}</div>
                              </div>

                              <div class="col-12 block_row email_row" v-if="isShowStudentEmail">
                                <div class="ic_container">
                                  <span class="ic ic9-email"></span>
                                </div>
                                <span class="block_val user_email ace_sec_txt" :aria-label="advisee.userEmail">{{advisee.userEmail}}</span>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 additional_info">
                        <div class="row">
                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            <template v-if="isShowProgramName">
                              <div class="row">
                                <div class="col-12 block_row block_tp_row program" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].majorTitle && advisee.adviseeSharedStreams[0].majorTitle.length > 0">
                                  <!--<div class="block_label" tabindex="0">{{majorLabel}}: </div>-->
                                  <div class="ic_container">
                                    <span class="ic ic8-degree" style="margin-left: -4px; margin-top: -2px;"></span>
                                  </div>
                                  <div class="block_val" style="font-size: 16px;">{{advisee.adviseeSharedStreams[0].majorTitle}}</div>
                                </div>
                              </div>
                            </template>
                          </div>

                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            <div class="icon_container" v-if="!isProspectiveStudent">
                              <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0">
                                <template v-if="redirectStreamToProgressView">
                                  <b-link class="view_plan btn" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamProgress', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                                    <span class="icon-stream"></span>
                                    <span class="title">view plan</span>
                                  </b-link>
                                </template>
                                <template v-else>
                                  <b-link class="view_plan btn" v-if="advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamPlanner', params: { uuid: advisee.adviseeSharedStreams[0].uuid }}">
                                    <span class="icon-stream"></span>
                                    <span class="title">view plan</span>
                                  </b-link>
                                </template>
                                <template v-if="isLockStreamEnabled">
                                  <b-link class="access_plan" v-if="isLocked(advisee.adviseeSharedStreams[0])" @click.stop.prevent="unlockStreamClicked(advisee.adviseeSharedStreams[0])">
                                    <span class="ic ico-lock" style="margin-top: -5px;"></span>
                                    <span class="title">Locked</span>
                                  </b-link>
                                  <b-link class="access_plan" v-else @click.stop.prevent="lockStreamClicked(advisee.adviseeSharedStreams[0])">
                                    <span class="ic ico-unlock"></span>
                                    <span class="title">Unlocked</span>
                                  </b-link>
                                </template>
                              </template>
                              <template v-else>
                                <template v-if="!isAutomaticStreamShareTurnedOn">
                                  <b-link class="view_plan">
                                    <span class="icon-stream"></span>
                                    <span class="title" style="cursor: pointer;" @click="requestAccessToPlanningStream(advisee)">Request Access</span>
                                  </b-link>
                                </template>
                              </template>
                            </div>
                          </div>
                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="col-1 action">
                    <div class="channel_sec" style="margin-top: 2px;" v-if="isChannelEnabled">
                      <channel-unread-counter-tag  v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0" :externalId="advisee.adviseeSharedStreams[0].uuid"></channel-unread-counter-tag>
                    </div>
                  </div>
                </div>


                <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10">
                  <div class="row" style="padding-top: 0px; padding-bottom: 0px; border: none;">
                    <div class="block col-xl-12 col-lg-12 col-md-12 col-sm-12">
                      <div class="row">
                        <div class="col-11">
                          <div class="row">
                            <div class="col-6">
                              <div class="row">






                              </div>
                            </div>
                          </div>

                        </div>


                      </div>


                    </div>
                    <div class="block additional_info col-xl-5 col-lg-12 col-md-12 col-sm-12" style="padding-right: 0px;">
                      <div class="row">

                        <div class="block_row ace_sec_txt col-xl-12 col-lg-8 col-md-12 col-sm-12" style="margin-top: 2px; padding-right: 0px; height: auto;" v-if="isCocuricularVerificationFeature">
                          <template v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].coCurricularStatusMap">
                            <template v-if="advisee.adviseeSharedStreams[0].coCurricularStatusMap.total > 0">
                              <span style="font-size: 14px;">Co-curricular Verification Requests:</span> <br/>
                              <span>Total - {{advisee.adviseeSharedStreams[0].coCurricularStatusMap.total}}</span> /
                              <span style="cursor: pointer; color: #157099;" @click="goToTimeView(advisee.adviseeSharedStreams[0].uuid)">Pending - {{advisee.adviseeSharedStreams[0].coCurricularStatusMap.pending}}</span>
                            </template>
                            <template v-else>
                              <span style="font-size: 14px;">Co-curricular Verification Requests:</span> <br/>
                              <span>Total - 0</span> /
                              <span style="cursor: pointer; color: #157099;" @click="goToTimeView(advisee.adviseeSharedStreams[0].uuid)">Pending - 0</span>
                            </template>
                          </template>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
              <!-- .row -->
            </div>
            <div v-if="!namedQueriesEnabled && advisees.length === 0 && !showLoader" class="no-result ace_sec_txt" aria-label="No Results Found">
              No Results Found
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-5 col-md-12 col-sm-12 report_sec" v-if="!namedQueriesEnabled">
        <div class="rgt_pan">
          <div class="card ace_sec" aria-level="2" aria-label="Activity Section">
            <div class="card-header">
              <span class="icon icon-activity" style="margin-top: -2px; margin-left: -2px; font-size: 42px;"></span>
              <span class="label ace_sec_hd" role="heading" aria-label="Activity" style="width: 110px;">Reports</span>
              <div class="more-link">
                <b-link class="hd_lnk" @click="navigateToReports()">more</b-link>
              </div>
            </div>
            <div class="card-body">
              <template v-for="c in dashboardReports">
                <div class="row report_sec_block" @click="navigateToReports()">
                  <div class="col-12 hd ace_sec_hd" :aria-label="c.title">
                    <span>{{c.title}}</span>
                  </div>
                  <div class="col-12">
                    <report :selectedReport="c" :type="c.visualizationType" :timeperiod="'60'"></report>
                  </div>
                </div>
              </template>
              <template v-if="dashboardReports.length == 0">
                <div class="row">
                  <div class="col-12">
                    <dummy-graph ref="DummyGraph"></dummy-graph>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div>
      <b-modal class="delete-folder-popup select_all_modal" ref="selectAllModal" hide-header ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc>
          <div>
              <span>{{ selectAllMessage }}</span>
          </div>
        <div slot="modal-header" class="popover-header">
          <button class="btn_close" aria-label="close" @click="hideSelectAllBox">
             <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-button @click="selectAllAndHideBox" class="btn button-primary float-right mr-2" aria-label="yes"> Select all </b-button>
            <b-button @click="hideSelectAllBox" class="btn button-primary float-right mr-2" aria-label="no"> cancel </b-button>
        </div>
      </b-modal>
    </div>


    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal id="course-report-popup" class="full_screen_modal" ref="learnerCourseReportModal" :header-bg-variant="'academic-progress-popup-header'" size="" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt text-center" style="width: 80%;">
            <span style="padding-left: 18rem;">{{reportModalHeaderLabel}}</span>
          </div>
          <div class="float-right">
            <button class="btn_close" aria-label="close" @click="closeLearnerCourseReportModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <student-my-report v-if="selectedCourseForReporting" :uuid="selectedCourseForReporting.courseId" :entityId="selectedCourseForReporting.courseId" :userId="selectedCourseForReporting.userId"></student-my-report>

      </b-modal>
    </div>
<!-- --------- -->
    <div>
      <b-modal id="academic-progress-popup" class="full_screen_modal" ref="academicProgressModal1" :header-bg-variant="'academic-progress-popup-header'" size="" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt text-center">
            <span>{{modalHeaderLabel}}</span>
          </div>
          <div>
            <button class="btn_close" aria-label="close" @click="closeAcademicProgressModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

          <div class="pg_content">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
              <div class="row pg_sec">
                <div class="col-4 hd ace_sec_hd">
                  <div class="score_sec">
                    <div class="label">Score</div>
                    <div class="progress_block">
                      <span class="state" :class="statusClass(selectedProgramForModal)" style="height: 32px; width: 70px;">
                        <span v-if="selectedProgramForModal.isScoreNotAvailable" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
                        <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;">{{selectedProgramForModal.score}}%</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="progress-row" v-if="!showCourseProgress">
                    <div class="progress-bar-label"
                    :title="selectedProgramForModal.childrenCompleteCount + ' of ' + selectedProgramForModal.childrenCount + ' competencies'" v-b-tooltip.hover>
                      {{selectedProgramForModal.childrenCompleteCount}} of {{selectedProgramForModal.childrenCount}}
                    </div>
                    <b-progress :max="selectedProgramForModal.childrenCount">
                      <b-progress-bar :value="selectedProgramForModal.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                    </b-progress>
                  </div>
                  <div class="progress-row" v-else>
                      <div class="progress-bar-label ace_sec_txt" :aria-label="selectedProgramForModal.inprogressCourses + ' of ' + selectedProgramForModal.totalCourses + ' courses'"></div>
                      <b-progress :max="selectedProgramForModal.totalCourses" height="32px">
                        <b-progress-bar :value="selectedProgramForModal.completedCourses" :title="showBarTitle(selectedProgramForModal.completedCourses, 'completed')" :aria-label="showBarTitle(selectedProgramForModal.completedCourses, 'completed')" class="prog_bar__completed" v-b-tooltip.hover> {{selectedProgramForModal.completedCourses}} </b-progress-bar>
                        <b-progress-bar :value="selectedProgramForModal.inprogressCourses" :title="showBarTitle(selectedProgramForModal.inprogressCourses, 'in-progress')" :aria-label="showBarTitle(selectedProgramForModal.inprogressCourses, 'in progress')" class="prog_bar__in_progress" v-b-tooltip.hover> {{selectedProgramForModal.inprogressCourses}} </b-progress-bar>
                        <b-progress-bar :value="selectedProgramForModal.notStartedCourses" :title="showBarTitle(selectedProgramForModal.notStartedCourses, 'not started')" :aria-label="showBarTitle(selectedProgramForModal.notStartedCourses, 'not started')" class="prog_bar__not_started" v-b-tooltip.hover> {{selectedProgramForModal.notStartedCourses}} </b-progress-bar>
                      </b-progress>
                    </div>
                </div>

                <div class="col-4 btn_container">
                  <b-button class="float-right" v-if="customAdvisorAllowUnenroll()" @click="openLearnerUnenrollModal(selectedProgramForModal)" style="margin-top: 1px; padding: 5px 18px; margin-left: auto; ">
                    <span >unenroll</span>
                  </b-button>
                </div>

                <learner-courses :parent="selectedProgramForModal" :parentTitle="selectedProgramForModal.programTitle" :pObject="this" :formattedProgramGuide="selectedProgramForModal" :courses="selectedProgramForModal.courses" :learnerUserId="selectedProgramForModal.currentAdvisee.userId">
                </learner-courses>

                <template v-if="selectedProgramForModal.courses.length==0">
                <div class="col-12 sec_content self_reported_courses">
                  <b-jumbotron>
                    <h4 class="text-center ace_sec_txt">Academic Progress is currently not available.</h4>
                  </b-jumbotron>
                </div>
                </template>

              </div>
            </div>
          </div>


      </b-modal>
    </div>

<!--   -->
<!-- Unlock Model -->
    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerCourseReleaseModal" class="description_modal" size="md" id="course-report-popup" hide-footer >
        <div slot="modal-header" class="header-section">
          <div class="ic_container">
            <span class="ic ic22-lock" v-if="!releaseStatus"></span>
            <span class="ic ic22-unlock" v-else></span>
          </div>
          <div class="head_txt align-middle">{{releaseModalHeaderLabel}}</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerCourseReleaseModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-12 txt_row">
            <div v-html="selectedCourseForReleaseTitle"></div>
          </div>
          <div class="col-12 txt_row">
            <div v-html="releaseLogicDetail"></div>
          </div>
          <div class="col-12 txt_row" >
            <div v-if="!releaseStatus">
            </div>
            <div v-else>
              Unlocked By <strong><i>{{releaseStatusUpdatedBy}}  {{millisToDate(releaseStatusUpdatedTime)}} </i></strong>
            </div>
          </div>
          <div class="col-12 txt_row btn_container">
            <b-button class="btn" @click="closeLearnerCourseReleaseModal">ok</b-button>
            <template v-if="!releaseStatus">
              <b-button class="btn" @click="manualRelease">unlock course</b-button>
            </template>
            <template v-if="releaseStatus">
              <b-button class="btn" @click="manualLock">lock course</b-button>
            </template>
          </div>
        </div>
      </b-modal>
    </div>
<!-- Unlock Model End-->
<!-- Unenroll Model -->
    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerUnenrollModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">Unenroll User</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerUnenrollModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div v-if="selectedProgramForModal">
            Unenroll {{selectedProgramForModal.currentAdvisee.userName}} from {{selectedProgramForModal.programTitle}}
          </div>
        </div>
        <div class="row txt_row">
          <div>
            <div>Are you sure?</div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeLearnerUnenrollModal">cancel</b-button>
            <b-button @click="unenrollUserFromProgram">unenroll</b-button>
          </div>
        </div>
      </b-modal>
    </div>

<!-- Unenroll Model End -->
<!-- Waive Model -->

    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerCourseWaiveModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt" style="margin-top: 1px;">{{waiveModalHeaderLabel}}</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerCourseWaiveModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div class="col-3 fld_label">
            Course
          </div>
          <div class="col-9 fld_val">
            <div v-html="selectedCourseForWaiveTitle"></div>
          </div>
        </div>

        <div class="row txt_row mt-3" v-if="waiveStatus">
          <div class="col-3 fld_label">
            Reason
          </div>
          <div class="col-9 fld_val">
              <span v-html="waiveLogicDetail"></span> <br/>
              Waived By <strong><i>{{waiveStatusUpdatedBy}}  {{millisToDate(waiveStatusUpdatedTime)}} </i></strong>
          </div>
        </div>

        <template v-if="!waiveStatus">
          <div class="row txt_row mt-3">
            <div class="col-3 fld_label">
              Reason
            </div>
            <div class="col-9 fld_input">
              <textarea  placeholder="type reason for waiving" aria-label="reason for waiving" v-model="waiveLogicDetail" rows=3 />
            </div>
          </div>

          <div class="row txt_row mt-3">
            <div class="col-3 fld_label">
              % Score
            </div>
            <div class="col-9 fld_input">
              <input aria-label="score" v-model="waiveScore" size="4"> <span class="exp_info">example: 85</span>
            </div>
          </div>
        </template>

        <div class="row mt-4">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeLearnerCourseWaiveModal">cancel</b-button>
            <b-button @click="manualWaive" v-if="!waiveStatus">waive course</b-button>
          </div>
        </div>
      </b-modal>
    </div>
<!-- nWaive Model End-->

    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerCourseOverrideModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt" style="margin-top: 1px;">Edit Overall Score and Progress</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerCourseOverrideModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div class="col-6">
            Course :
          </div>
          <div class="col-6 fld_val">
            <div v-html="selectedCourseForOverrideTitle"></div>
          </div>
        </div>
        <div class="row txt_row">
          <div class="col-6">
            User :
          </div>
          <div class="col-6 fld_val">
            <div v-if="selectedCourseSummaryForOverride">
            {{selectedCourseSummaryForOverride.firstName}} {{selectedCourseSummaryForOverride.lastName}}
            </div>
          </div>
        </div>

          <div class="row txt_row mt-3">
            <div class="col-6 ">
              Actual Overall Score :
            </div>
            <div class="col-6 fld_input" v-if="selectedCourseSummaryForOverride">
              <span v-if="selectedCourseSummaryForOverride.overriddenTime" class="exp_info">{{selectedCourseSummaryForOverride.prePerformance?selectedCourseSummaryForOverride.prePerformance:0.00}}%</span>
              <span v-else class="exp_info">{{selectedCourseSummaryForOverride.performance}}%</span>

            </div>

          </div>

          <div class="row txt_row mt-3">
            <div class="col-6 ">
              Edited Overall Score :
            </div>
            <div class="col-6 fld_input">
              <input aria-label="score" v-model="overrideScore" size="4">%<span class="exp_info">example: 85</span>
            </div>
          </div>

          <div class="row txt_row mt-3">
            <div class="col-6 ">
              Actual Overall Progress :
            </div>
            <div class="col-6 fld_input" v-if="selectedCourseSummaryForOverride && selectedCourseSummaryForOverride.overriddenTime">
            <div class="progress-bar-label">
              {{selectedCourseSummaryForOverride.preChildrenCompleteCount}} of {{selectedCourseSummaryForOverride.childrenCount}}
            </div>
            <b-progress :max="selectedCourseSummaryForOverride.childrenCount">
              <b-progress-bar :value="selectedCourseSummaryForOverride.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
            </b-progress>
            </div>
            <div class="col-6 fld_input" v-else-if="selectedCourseSummaryForOverride">
            <div class="progress-bar-label">
              {{selectedCourseSummaryForOverride.childrenCompleteCount}} of {{selectedCourseSummaryForOverride.childrenCount}}
            </div>
            <b-progress :max="selectedCourseSummaryForOverride.childrenCount">
              <b-progress-bar :value="selectedCourseSummaryForOverride.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
            </b-progress>
            </div>
          </div>
          <div class="row txt_row mt-3" v-if="selectedCourseSummaryForOverride && selectedCourseSummaryForOverride.overriddenTime>0">
            <div class="col-6 ">
              Edited Overall Progress :
            </div>
            <div class="col-6 fld_input" >
            <div class="progress-bar-label">
              {{selectedCourseSummaryForOverride.childrenCompleteCount}} of {{selectedCourseSummaryForOverride.childrenCount}}
            </div>
            <b-progress :max="selectedCourseSummaryForOverride.childrenCount">
              <b-progress-bar :value="selectedCourseSummaryForOverride.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
            </b-progress>
            </div>
          </div>
        <div class="row mt-4">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeLearnerCourseOverrideModal">
              {{ $tf('cancel') }}
            </b-button>
            <b-button @click="manualOverride">
              {{ $tf('save', 'save') }}
            </b-button>

          </div>
        </div>
      </b-modal>
    </div>

  </div>

</template>

<script>
import _ from 'lodash'
//import '../../../assets/module/css/adviseeTracker/adviseeDetails.min.css'
import { mapState, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import Report from '../../institution/components/Report'
import DummyGraph from '../../dashboard/components/dummyGraph'
import ChannelCalendarNoteActionMenu from './ChannelCalendarNoteActionMenu'
import StudentMyReport from '../../course/components/StudentMyReport'
import ChannelUnreadCounterTag from '../../channel/components/ChannelUnreadCounterTag'
import AdviseeProgramCourseScoreAndProgress from './AdviseeProgramCourseScoreAndProgress'
import LearnerCourses from './LearnerCourses'
export default {
  name: 'adviseeTracker',
  props: ['isProspectiveStudent'],
  components: {
    Report,
    DummyGraph,
    ChannelUnreadCounterTag,
    ChannelCalendarNoteActionMenu,
    StudentMyReport,
    AdviseeProgramCourseScoreAndProgress,
    LearnerCourses
  },
  data: () => {
    return {
      showLoader: false,
      name: '',
      lockStreamFlagName: 'lockStream',
      userReports: [],
      groups: [],
      currentGroup: '',
      groupToShow: [],
      currentPage:1,
      pageSize:20,
      firstPage: false,
      lastPage: false,
      selectAllMessage: '',
      selectedItemMessage: '',
      selectAllPages : 'Select All',
      pageSelected :false,
      selectedUserUuids: [],
      namedQueries: [],
      namedQueriesEnabled: false,
      allUsers: [],
      userTags: {},
      areTagsReady: false,
      searchQuery: '',
      selectedTags: [],
      namedQueryToShow: {},
      tagsResponse: {},
      reportModalHeaderLabel: '',
      selectedCourseForReporting : null,
      selectedProgramForModal : {programCode: 'AIPLAYER101', programTitle:"Testing 1111",  score:70, childrenCount:8, childrenCompleteCount:3, totalCourses:0, completedCourses:0, notStartedCourses:0, inprogressCourses:0, isScoreNotAvailable:false, courses:[], currentAdvisee:{}},
      modalHeaderLabel : '',
      waiveModalHeaderLabel :'',
      selectedCourseForWaiveTitle :'',
      selectedCourseForWaive : {},
      waiveLogicDetail : '',
      waiveStatusUpdatedBy : '',
      waiveStatusUpdatedTime : '',
      waiveStatus : false,
      waiveScore : 0,
      selectedCourseForRelease: null,
      releaseModalHeaderLabel:'',
      releaseLogicDetail : '',
      releaseStatus : true,
      releaseStatusUpdatedBy : 'System',
      releaseStatusUpdatedTime: undefined,
      selectedCourseForReleaseTitle : '',
      selectedCourseForOverrideTitle : '',
      selectedCourseSummaryForOverride : null,
      selectedCourseForOverride : null,
      overrideScore : '',
      overrideStatusUpdatedBy : 'System',
      overrideStatusUpdatedTime: undefined,

      courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
      },
      courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        }


    }
  },

  mounted () {
    this.loadUpdatePageCount({page: 0, count: 20})
    this.loadAdviseeTracker()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadAdvisees',
      'loadUpdatePageCount',
      'loadLogDashboardActivity',
      'loadRequestAccessToPlanningStream',
      'lockStream',
      'unlockStream',
      'releaseCourse',
      'loadUserReports',
      'loadNamedQueries',
      'loadPersonTags',
      'loadAdviseesPersonTags',
      'loadInpersonateUser',
      'setUserInfo',
      'waiveCourse',
      'setInpersonateUserInfo',
      'exportProspectiveStudentsToCsv',
      'loadExportNamedQueriesToCsv',
      'changeProgramEnrollment',
      'populateStreamStructure',
      'loadStreamWithStructure',
      'loadStreamWithStructureSummary',
      'unenrollFromProgram',
      'overrideCourseScore'
    ]),
    getHumandReadableTime (value) {
      if (Number(value) > 1000000) {
        let date = new Date(Number(value))
        return date.toDateString()
      }
      return value
    },
    getHumandReadableTimeTaken(timeTaken){
      if (timeTaken < 1) {
        return 'N/A'
      }

      var ms = timeTaken % 1000
      timeTaken = (timeTaken - ms) / 1000
      var secs = timeTaken % 60
      timeTaken = (timeTaken - secs) / 60
      var mins = timeTaken % 60
      var hrs = (timeTaken - mins) / 60
      if (hrs < 10) {
        hrs = '0' + hrs
      }
      if (mins < 10) {
        mins = '0' + mins
      }
      if (secs < 10) {
        secs = '0' + secs
      }
      return hrs + ':' + mins + ':' + secs
    },
    resetData (data) {
        if(!data){
          return data
        }
        data.score = 0
        data.courses = []
        data.performance = 0
        data.childrenCount = 0
        data.childrenCompleteCount = 0
        data.progressSummaryCount = 0
        data.isScoreNotAvailable = true
        data.totalCourses = 0
        data.completedCourses = 0
        data.inprogressCourses = 0
        data.notStartedCourses = 0
        data.currentAdvisee = {}
        return data
      },

    async populateStreamStructure (data) {
        let stream = await this.loadStreamWithStructure({programCode: data.programCode, userId: data.userId})
        let structure = stream.structure
        if (structure) {
          let children = JSON.parse(structure)

          if (children.length > 0) {
            let childStructure = children[0].structure
            if (children.length >2) {
                childStructure = structure
            }

            if (childStructure) {
              let cStructure = JSON.parse(childStructure)
              data.courses = _.sortBy(cStructure, 'order')
              let summaries = await this.loadStreamWithStructureSummary({programCode: data.programCode, userId: data.userId})
              let performance = undefined
              let performanceCount=0
              data.inprogrerssCourses = 0
              for (let i = 0; i < summaries.length; i++) {
                  let competencySummary =  summaries[i]
                  data.childrenCount += competencySummary.childrenCount
                  data.childrenCompleteCount += competencySummary.childrenCompleteCount
                  data.totalCourses = data.courses.length

                  if(competencySummary.status==2){
                    data.completedCourses+=1
                  }
                  if(competencySummary.status==1){
                    data.inprogressCourses = data.inprogressCourses+1
                  }

                  if(competencySummary.performance) {
                      performanceCount++
                      if(performance == undefined){
                          performance = competencySummary.performance
                      }else{
                          performance += competencySummary.performance
                      }
                  }
              }
              if(performance !=undefined) {
                data.isScoreNotAvailable = false
                data.score =(performance / performanceCount).toFixed(2)
                data.performance=performance
              }
              let catalogAndCourses = this.getTotalCourseCatalogs(data.courses)
              data.totalCourses = catalogAndCourses.length
              data.notStartedCourses = (data.totalCourses - (data.inprogressCourses+data.completedCourses))
            }
          }
        }
        return data
      },
      statusClass (data) {
        if (data.score && !data.isScoreNotAvailable) {
          if (data.score >= 90) {
            return 'gradeA'
          } else if (data.score >= 80 && data.score < 90) {
            return 'gradeB'
          } else if (data.score >= 65 && data.score < 80) {
            return 'gradeC'
          } else if (data.score >= 40 && data.score < 65) {
            return 'gradeD'
          } else if (data.score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },
      getCoursesFromFolder (folder) {
        let courses = []
        if(!folder.structure){
            return courses
        }
        let structure = JSON.parse(folder.structure)
        if (structure) {
          let recursionEntities = _.sortBy(structure, 'order')
          recursionEntities.forEach((item, i) => {
            if (item.entityType === 'deliverycontext' || item.entityType === 'catalog' ) {
              courses.push(item)
            }
          })
        }
        return courses
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      aggregateProgressSummary (progressSummary) {
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      isReporcessEnrollmentEnabled () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'reprocessEnrollment') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      millisToDate (millis) {
        if(millis){
          return 'on ' + DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
        }else{
            return ''
        }

      },
    mouseOver (advisee) {
      let ref = 'action-menu-' + advisee.userId
      if (this.$refs[ref] && this.$refs[ref].length > 0 && this.selectedUserUuids.length < 2) {
        this.$refs[ref][0].active = true
      }
    },
      manualWaive () {
          this.waiveCourse({uuid:this.selectedCourseForWaive.uuid, details:this.waiveLogicDetail, score:this.waiveScore, status:!this.waiveStatus})
          this.waiveModalHeaderLabel = ''
          this.selectedCourseForWaiveTitle = ''
          this.$refs.learnerCourseWaiveModal.hide()
          this.selectedCourseForWaive = null
          this.waiveLogicDetail = ''
          this.waiveScore = ''
          this.waiveStatus = false
          this.waiveStatusUpdatedBy = 'System'
          this.waiveStatusUpdatedTime =undefined
      },
      manualOverride () {
          if(!this.overrideScore || this.overrideScore>100 || this.overrideScore<1){
              alert('Edited Overall Score must be between 1 and 100')
              return
          }
        this.overrideCourseScore({uuid:this.selectedCourseForOverride.uuid, score:this.overrideScore}).then(prg => {
          this.selectedCourseForOverrideTitle = ''
          this.$refs.learnerCourseOverrideModal.hide()
          this.selectedCourseForOverride = null
          this.selectedCourseSummaryForOverride = null
          this.overrideScore = ''
          this.overrideStatusUpdatedBy = 'System'
          this.overrideStatusUpdatedTime =undefined
        })
      },
      manualLock () {
          this.releaseCourse({uuid:this.selectedCourseForRelease.uuid, status:false})
          this.releaseModalHeaderLabel = ''
          this.selectedCourseForReleaseTitle = ''
          this.$refs.learnerCourseReleaseModal.hide()
          this.selectedCourseForRelease = null

          this.releaseLogicDetail = ''
          this.releaseStatus = true
          this.releaseStatusUpdatedBy = 'System'
          this.releaseStatusUpdatedTime =undefined

      },
      manualRelease () {
          this.releaseCourse({uuid:this.selectedCourseForRelease.uuid, status:true})
          this.releaseModalHeaderLabel = ''
          this.selectedCourseForReleaseTitle = ''
          this.$refs.learnerCourseReleaseModal.hide()
          this.selectedCourseForRelease = null

          this.releaseLogicDetail = ''
          this.releaseStatus = true
          this.releaseStatusUpdatedBy = 'System'
          this.releaseStatusUpdatedTime =undefined

      },

      openWaiveDetailModal (course, unlocked) {
        this.waiveModalHeaderLabel = course.waiveStatus?'Course is Waived':'Course is Not Waived'
        this.selectedCourseForWaiveTitle = course.title
        this.$refs.learnerCourseWaiveModal.show()
        this.selectedCourseForWaive = course
        this.waiveLogicDetail = course.waiveLogicDetail
        this.waiveStatusUpdatedBy = course.waiveStatusUpdatedBy
        this.waiveStatusUpdatedTime = course.waiveStatusUpdatedTime
        this.waiveStatus = unlocked
      },
      closeLearnerCourseWaiveModal () {
        this.waiveModalHeaderLabel = ''
        this.selectedCourseForWaiveTitle = ''
        this.$refs.learnerCourseWaiveModal.hide()
        this.selectedCourseForWaive = null
        this.waiveLogicDetail = ''
        this.waiveScore = ''
        this.waiveStatus = false
        this.waiveStatusUpdatedBy = 'System'
        this.waiveStatusUpdatedTime =undefined
      },
      openOverrideDetailModal (course, tempsummary) {
        this.selectedCourseForOverrideTitle = course.title
        this.selectedCourseForOverride = course
        this.selectedCourseSummaryForOverride = tempsummary
        this.overrideScore = tempsummary.overriddenTime?tempsummary.performance:''
        this.overrideStatusUpdatedBy = course.overrideStatusUpdatedBy
        this.overrideStatusUpdatedTime = course.overrideStatusUpdatedTime
        this.$refs.learnerCourseOverrideModal.show()
      },
      closeLearnerCourseOverrideModal () {
        this.selectedCourseForOverrideTitle = ''
        this.$refs.learnerCourseOverrideModal.hide()
        this.selectedCourseForOverride = null
        this.selectedCourseSummaryForOverride = null
        this.overrideScore = ''
        this.overrideStatusUpdatedBy = 'System'
        this.overrideStatusUpdatedTime =undefined
      },
      openReleaseDetailModal (course, unlocked) {
        this.releaseModalHeaderLabel = course.releaseStatus?'Course is Unlocked':'Course is Locked'
        this.selectedCourseForReleaseTitle = course.title
        this.$refs.learnerCourseReleaseModal.show()
        this.selectedCourseForRelease = course
        this.releaseLogicDetail = course.releaseLogicDetail
        this.releaseStatusUpdatedBy = course.releaseStatusUpdatedBy
        this.releaseStatusUpdatedTime = course.releaseStatusUpdatedTime
        this.releaseStatus = unlocked
      },
      closeLearnerCourseReleaseModal () {
        this.releaseModalHeaderLabel = ''
        this.selectedCourseForReleaseTitle = ''
        this.$refs.learnerCourseReleaseModal.hide()
        this.selectedCourseForRelease = null
        this.releaseLogicDetail = ''
        this.releaseStatus = true
        this.releaseStatusUpdatedBy = 'System'
        this.releaseStatusUpdatedTime =undefined
      },
      openLearnerUnenrollModal (program, advisee) {
        this.$refs.learnerUnenrollModal.show()
      },
      closeLearnerUnenrollModal () {
        this.$refs.learnerUnenrollModal.hide()
      },
      unenrollUserFromProgram (){
          this.$refs.learnerUnenrollModal.hide()
          this.unenrollFromProgram({userId:this.selectedProgramForModal.currentAdvisee.userId, programCode:this.selectedProgramForModal.programCode} )
          setTimeout(() => {
            window.location.reload()
          }, 2000)
      },

    openLearnerCourseReportModal (currentAdvisee, courseId) {
      this.reportModalHeaderLabel = currentAdvisee.userName + '\'s View of Course Report'
      this.$refs.learnerCourseReportModal.show()
      this.selectedCourseForReporting = {courseId:courseId, userId:currentAdvisee.userId}
    },
    closeLearnerCourseReportModal () {
      this.reportModalHeaderLabel = ''
       this.selectedCourseForReporting = null
      this.$refs.learnerCourseReportModal.hide()
    },
    openAcademicProgressModal (currentAdvisee, programCode, programTitle) {

      this.modalHeaderLabel = currentAdvisee.userName + '\'s Academic Progress for ' + programTitle
      this.selectedProgramForModal = this.resetData(this.selectedProgramForModal)
      this.selectedProgramForModal.programCode = programCode
      this.selectedProgramForModal.programTitle = programTitle
      this.selectedProgramForModal.userId = currentAdvisee.userId
      this.selectedProgramForModal.currentAdvisee = currentAdvisee
      this.populateStreamStructure(this.selectedProgramForModal).then(prg => {
        this.selectedProgramForModal = prg
        this.$refs.academicProgressModal1.show()
      })
    },
    closeAcademicProgressModal () {
      this.modalHeaderLabel = ''
      this.selectedCourseForReporting = null
      this.$refs.academicProgressModal1.hide()
    },

    mouseLeave (advisee) {
      let ref = 'action-menu-' + advisee.userId
      if (this.$refs[ref] && this.$refs[ref].length > 0) {
        if (advisee.userRole == 'Prospective Student') {
          //let isVisible = this.$refs[ref][0].$refs['taggingActionMenu'].isActionModalVisible || this.$refs[ref][0].$refs['calendarEventActionMenu'].isActionModalVisible
          let isVisible = this.$refs[ref][0].$refs['taggingActionMenu'].isActionModalVisible || (this.$refs[ref][0].$refs['calendarEventActionMenu'] && this.$refs[ref][0].$refs['calendarEventActionMenu'].isActionModalVisible)
          if (!isVisible) {
            this.$refs[ref][0].active = false
          }
        } else {
          //let isVisible = this.$refs[ref][0].$refs['taggingActionMenu'].isActionModalVisible || this.$refs[ref][0].$refs['calendarEventActionMenu'].isActionModalVisible || this.$refs[ref][0].$refs['noteActionMenu'].isActionModalVisible || this.$refs[ref][0].$refs['channelActionMenu'].isActionModalVisible
          let isVisible = this.$refs[ref][0].$refs['taggingActionMenu'].isActionModalVisible || (this.$refs[ref][0].$refs['calendarEventActionMenu'] && this.$refs[ref][0].$refs['calendarEventActionMenu'].isActionModalVisible) || this.$refs[ref][0].$refs['noteActionMenu'].isActionModalVisible
          if (!isVisible) {
            this.$refs[ref][0].active = false
          }
        }
      }
    },
    getTagContainerRowWidth (rowNo) {
      let tagsRowWidth = $('#tagsRow_' + rowNo).innerWidth()
      let tagContainerWidth = $('#tagsContainer_' + rowNo).innerWidth()
      if (tagContainerWidth > 20) {
        $('#showMoreTagsBtn_' + rowNo).addClass('')
      }
    },
    navigateToReports () {
      return this.$router.push({ name: 'recruiterReport' })
    },
    getChangeProgram (advisee){
      let key = 'Program change requests_Requested Program'
      return advisee.namedQueryInfoMap[key]
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    showLoading () {
      this.showLoader = true
      if (this.$refs.loadingModal) {
         this.$refs.loadingModal.show()
      }
    },
    hideLoading () {
      this.showLoader = false
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },
    addToSelectedTags (item) {
      var index = this.selectedTags.indexOf(item)
      if (index === -1) {
        this.selectedTags.push(item)
      }
    },
    removeFromSelectedTags (item) {
      var index = this.selectedTags.indexOf(item)
      if (index !== -1) {
        this.selectedTags.splice(index, 1);
      }
    },
    sortEnrollmentDate () {
      this.groupToShow.sort((a,b) => this.getOrder(a,b))
    },
    getOrder (a, b) {
      const key = this.currentGroup + '_Enrollment Date'
      const aDate = a.namedQueryInfoMap && a.namedQueryInfoMap[key]
      const bDate = b.namedQueryInfoMap && b.namedQueryInfoMap[key]

      const aHasDate = !!aDate
      const bHasDate = !!bDate

      if (!aHasDate && !bHasDate) return 0
      if (!aHasDate) return 1   // a has no date → a goes to bottom
      if (!bHasDate) return -1  // b has no date → a stays on top

      return (aDate > bDate) ? 1 : ((bDate > aDate) ? -1 : 0)
    },
    sortAsc () {
      this.groupToShow.sort((a,b) => (a.userName > b.userName) ? 1 : ((b.userName > a.userName) ? -1 : 0))
      $('.pg_sec_menu .lnk_menu').removeClass('active')
      $('#sortLinkAsc').addClass('active')
    },
    sortDesc () {
      this.groupToShow.sort((a,b) => (a.userName < b.userName) ? 1 : ((b.userName < a.userName) ? -1 : 0))
      $('.pg_sec_menu .lnk_menu').removeClass('active')
      $('#sortLinkDes').addClass('active')
    },
    async loadAdviseeTracker () {
      this.loadLogDashboardActivity({action: 'viewAdviseeTracker', page: 'adviseeTracker', link: ''})
      this.showLoading()
      this.showLoader = true

      // Get Named Queries
      this.namedQueries = await this.loadNamedQueries()
      let allAdviseesFound = false
      if (this.namedQueries && this.namedQueries.length > 0) {
        this.$store.commit('LOAD_NAMED_QUERY_ENABLED', true)
        this.namedQueriesEnabled = true
        this.namedQueries.forEach((item, i) => {
          let group = {
            'name': item.namedQuery.title,
            'members': [],
            'headers': []
          }
          if (item.namedQuery.headers) {
            group.headers.push(...item.namedQuery.headers)
          }
          group.members.push(...item.adviseeStatusList)
          this.allUsers.push(...item.adviseeStatusList)
          if (group.name === 'All Advisees') {
            allAdviseesFound = true
          }
          this.groups.push(group)
        })
      } else {
        this.$store.commit('LOAD_NAMED_QUERY_ENABLED', false)
        await this.loadAdvisees({name: this.name})
      }

      if (allAdviseesFound) {
        this.currentGroup = 'All Advisees'
      } else {
        this.currentGroup = this.groups[0].name
      }

      if (!this.namedQueriesEnabled) {
        this.userReports = await this.loadUserReports()
      }
      if (this.namedQueriesEnabled) {
        this.tagsResponse = await this.loadAdviseesPersonTags()
        let tagList = {}
        let tags = {}
        for (let user of this.allUsers) {
          this.userTags[user.userId] = []
          tags = this.tagsResponse[user.userId]
          if (tags) {
            for (const [key, value] of Object.entries(tags)) {
              value.forEach((tag, index) => {
                this.userTags[user.userId].push(tag.name)
              })
            }
          }
        }
        this.areTagsReady = true
      }
      this.showLoader = false
      this.hideLoading()
    },
    next (){
      let total = this.groupToShow.length
      this.currentPage = this.currentPage+1
    },
    prev (){
        this.currentPage = this.currentPage-1
    },
    selectAll () {
      let selectedPageUserUuids = []
      for(let i=0; i<this.groupToShow.length; i++){
        selectedPageUserUuids[i] = {'userUuid': this.groupToShow[i].userId, 'role': this.groupToShow[i].userRole}
      }
      this.selectedUserUuids = selectedPageUserUuids
      this.selectedItemMessage = this.groupToShow.length + ' of ' +this.groupToShow.length+ ' selected'
    },
    selectPage () {
      if(!this.$refs['selectcurrentPageCheckbox'].checked){
        this.selectedUserUuids = []
        this.selectedItemMessage=''
        return
      }
      let total = this.groupToShow.length
      let from = 1 + this.pageSize*(this.currentPage-1)
      let to = this.pageSize*this.currentPage
      let selectedPageUserUuids = []
      if(to > total || total==0){
          to = total
      }
      if(total ==0){
        from = 0
      }
      for(let i=from; i<=to; i++){
        selectedPageUserUuids[i-from] = {'userUuid': this.groupToShow[i-1].userId, 'role': this.groupToShow[i-1].userRole}
      }
      this.selectedUserUuids = selectedPageUserUuids
      if(total>this.selectedUserUuids.length){
          this.showDeleteFolderConfirmBox(this.selectedUserUuids.length, total)
      }
      this.selectedItemMessage = this.selectedUserUuids.length + ' of ' +total+ ' selected'
    },
    rangeValue () {
      let total = this.groupToShow.length
      let from = 1 + this.pageSize*(this.currentPage-1)
      let to = this.pageSize*this.currentPage
      let range = from + '-' + to
      if(to > total || total==0){
          to = total
          range = total
          this.lastPage = true
      }else{
        this.lastPage = false
      }
      if(from==1 || total ==0){
        this.firstPage=true
      }else{
        this.firstPage=false
      }
      if(total ==0){
        from = 0
        range = 0
      }
      //return to+'  of  '+ total
      return range + ' of ' + total
    },
    showDeleteFolderConfirmBox (n, total) {
      this.selectAllMessage = 'You have selected '+n+' out of '+total+'. Do you want to select all '+total+'?'
      this.$refs.selectAllModal.show()
    },
    hideSelectAllBox () {
      this.$refs.selectAllModal.hide()
    },
    selectAllAndHideBox () {
      this.selectAll()
      this.$refs.selectAllModal.hide()
    },

    clickNext () {
      this.loadUpdatePageCount({page: this.page + 1, count: this.count})
      this.loadAdviseeTracker({name: this.name})
    },
    clickPrev () {
      this.loadUpdatePageCount({page: this.page - 1, count: this.count})
      this.loadAdviseeTracker({name: this.name})
    },
    searchAdvisees () {
      this.loadUpdatePageCount({page: 0, count: 20})
      this.loadAdviseeTracker({name: this.name})
    },
    requestAccessToPlanningStream (advisee) {
      let adviseeName = advisee.userName
      this.showLoading()
      this.loadRequestAccessToPlanningStream(advisee.userId).then(message => {
        this.hideLoading()
        this.notifySuccess(message.replace('$$ADVISEE_NAME$$', adviseeName))
      })
    },
    async lockStreamClicked (stream) {
      let response = await this.lockStream(stream.uuid)
      if (!response) {
        this.notifyFailure('Unable to lock \'' + stream.title + '\'')
      }
      this.notifySuccess('Successfully locked \'' + stream.title + '\'')
      return this.loadAdviseeTracker()
    },
    async unlockStreamClicked (stream) {
      let response = await this.unlockStream(stream.uuid)
      if (!response) {
        this.notifyFailure('Failed to unlock \'' + stream.title + '\'')
      }
      this.notifySuccess('Successfully unlocked \'' + stream.title + '\'')
      return this.loadAdviseeTracker()
    },
    isLocked (stream) {
      if (!stream) {
        return false
      }
      return stream.locked || stream.isLocked
    },
    goToTimeView (uuid) {
      return this.$router.push({ name: 'streamTime', params: { uuid: uuid } })
    },
    makeArrayWithUserId (advisee) {
      let userIds = []
      let userob = {
        'userUuid': advisee.userId
      }
      userIds.push(userob)
      return userIds
    },
    getUserTags (userId) {

      if (userId in this.userTags) {
        return this.userTags[userId]
      }
      return []
    },
    changeGroup (newGroup) {
      this.currentGroup = newGroup.name
      this.computeGroupToShow()
    },
    computeGroupToShow () {
      let current = this.currentGroup
      this.selectedUserUuids = []
      this.selectedItemMessage=''
      this.pageSelected = false
      this.currentPage = 1
      this.groupToShow = []
      if (this.groups.length > 0) {
        this.groups.forEach((item, i) => {
          if (item.name === current) {
            this.namedQueryToShow = item
            // Filter By Tags
              item.members.forEach((item2, i) => {
                if (this.selectedTags.length > 0) {
                  if (this.selectedTags.every(val => this.userTags[item2.userId].includes(val))) {
                    this.groupToShow.push(item2)
                  }
                } else {
                  this.groupToShow.push(item2)
                }
              })
            // filter by searchQuery
            if (this.searchQuery.length > 0) {
              this.groupToShow = this.groupToShow.filter(member => member.userName.toLowerCase().includes(this.searchQuery.toLowerCase()) || this.isTagContains(member))
            }
          }
        })
      }
      // If Tag is selected Sort By Enrollment Date
      if (this.selectedTags.length > 0){
          this.sortEnrollmentDate()
      }

    },
    isTagContains(member) {
       return  this.userTags[member.userId].some(tag => tag.includes(this.searchQuery.toLowerCase()))
    },
    writeFile (data) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = 'prospective_students.csv'
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    async openActAsUserModal (userUuid) {
      let ref = 'actAsUserModal_' + userUuid
      this.$refs[ref][0].show()
    },
    async closeActAsUserModal (userUuid) {
      let ref = 'actAsUserModal_' + userUuid
      this.$refs[ref][0].hide()
    },
    async openChangeProgramModal (userUuid) {
      let ref = 'changeProgramrModal_' + userUuid
      this.$refs[ref][0].show()
    },
    async closeChangeProgramModal (userUuid) {
      let ref = 'changeProgramrModal_' + userUuid
      this.$refs[ref][0].hide()
    },
    actAsUser (advisee) {
        this.loadInpersonateUser(advisee.userId).then(res => {
          let status = res.status
          let userObj = res.data
          if (status === 200) {
              this.setUserInfo(userObj)
              this.setInpersonateUserInfo(userObj)
              let userRole = userObj.roles[0].role
              let role = userRole.toLowerCase()
              this.navigateToDashboard(role)
          }
        })
        // Track Start inpersonating
        this.loadLogDashboardActivity({action: 'startInpersonating', page: 'startInpersonating', link: ''})
    },
    isCustomAdvisor (){
        return this.userObj.customAdvisor
    },
    isDisableLearnerHome () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Disable Learner Home Page') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    customAdvisorWaive () {
      return this.customAdvisorfeature('Allow Waive Course')
    },
    customAdvisorUnlock () {
      return this.customAdvisorfeature('Allow Unlock Course')
    },
    customAdvisorAllowUnenroll () {
      return this.customAdvisorfeature('Allow Unenroll')
    },
    customAdvisorLearnerHome () {
      return this.customAdvisorfeature('Show Learner Home')
    },
    customAdvisorfeature (flagValue) {
      if(!this.isCustomAdvisor()){
          return true
      }
      let customAdvisorFeature = this.customAdvisorFeature
      if (customAdvisorFeature) {
        let flags = customAdvisorFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === flagValue) {
            return flags[i].enabled
          }
        }
      }
      return false
    },

    changeProgramForUser (advisee){
        let key = 'Program change requests_currentProgramCode'
        let key2 = 'Program change requests_requestedProgramCode'
        let currentProgramCode =advisee.namedQueryInfoMap[key]
        let requestedProgramCode =advisee.namedQueryInfoMap[key2]
        this.changeProgramEnrollment({userId:advisee.userId,currentProgramCode: currentProgramCode, requestedProgramCode: requestedProgramCode})
        this.closeChangeProgramModal(advisee.userId)
        setTimeout(() => {
            window.location.reload()
          }, 2000)


    },
    navigateToDashboard (userRole) {
        let role = userRole.toLowerCase()
        let url = '/user/track/' + role
        if ((role === 'instructor & admin') || (role === 'curator')) {
          url = '/user/track/admin'
        } else if (role === 'employer admin') {
          url = '/employer/admin'
        } else if (role === 'prospective student' || role === 'admitted student') {
          url = '/user/track/' + role.split(' ').join('_')
        } else if (role === 'widget admin') {
          url = '/user/track/' + role.split(' ').join('_')
        }
        this.$router.push(url)
        setTimeout(() => {
            window.location.reload()
          }, 500)

    },
    exportProspectiveStudents () {
      this.exportProspectiveStudentsToCsv().then(response => {
        let summaryCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
          return this.notifyFailure(errors)
        }
        this.writeFile(summaryCsvFile)
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
        } else {
          this.notifySuccess('Prospective Students Successfully Exported to Csv')
        }
      })
    },
    goToFullScreen (){
      return this.$router.push({ name: 'adviseeTracker' })
    },
    exportNamedQueryResults () {
      this.loadExportNamedQueriesToCsv({queryId:this.currentGroup,tags:this.selectedTags}).then(response => {
        let namedQueryResults = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!namedQueryResults || !namedQueryResults.length || namedQueryResults.length === 0) {
          return this.notifyFailure(errors)
        }
        this.writeFileNamedQueryResults(this.currentGroup+'.csv',namedQueryResults)
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
        } else {
          this.notifySuccess('Results Successfully Exported to Csv')
        }
      })
  },
  showBarTitle (count, status) {
    if (count > 1) {
      return count + ' courses are ' + status
    } else {
      return count + ' course is ' + status
    }
  },
  writeFileNamedQueryResults (fileName, data) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = fileName
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    }

  },


  computed: {
    ...mapState({
      'advisees': state => state.adviseeTracker.advisees,
      'total': state => state.adviseeTracker.total,
      'count': state => state.adviseeTracker.count,
      'page': state => state.adviseeTracker.page,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'userObj': state => state.user.userObj
    }),
    isSelectedUuidContainProspectiveStudent () {
      if (this.selectedUserUuids && this.selectedUserUuids.length > 0) {
        for (var i = 0; i < this.selectedUserUuids.length; i++) {
          if (this.selectedUserUuids[i] && (this.selectedUserUuids[i].role === 'Prospective Student')) {
            return true
          }
        }
      }
      return false
    },
    showExportNamedQuery () {
      for (var i = 0; i < this.namedQueries.length; i++) {
        let item = this.namedQueries[i]
        if (item.namedQuery.title === this.currentGroup && item.namedQuery.allowDownload) {
          return true
        }
      }
      return false
    },
    areTagsReadyComputed () {
      if (this.areTagsReady) {
        return true
      }
      return false
    },
    currUser () {
      return this.currentUserId
    },
    dashboardReports () {
      if (this.userReports.length > 0) {
        let dashboardReports = []
        this.userReports.forEach((item, i) => {
          if (item.showOnDashboard) {
            dashboardReports.push(item)
          }
        })
        return dashboardReports
      } else {
        return []
      }
    },
    isChannelEnabled () {
      let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNELS_FEATURE_ID]
      if (channelFeature) {
        return channelFeature.enabled
      }
      return false
    },
    advisorDashboardFeature () {
      return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
    },
    customAdvisorFeature () {
      return this.enabledFeatures['Custom Advisor']
    },
    isCocuricularVerificationFeature () {
      if (this.enabledFeatures && this.enabledFeatures[PACKAGE.FEATURE_IDS.COCURICULAR_VERIFICATION_FEATURE_ID]) {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.COCURICULAR_VERIFICATION_FEATURE_ID].enabled
      }
      return false
    },
    showPrev () {
      if (this.page > 0) {
        return true
      } else {
        return false
      }
    },
    showNext () {
      let pg = this.page
      let cnt = this.count
      var res = (pg + 1) * cnt
      if (res <= this.total) {
        return true
      } else {
        return false
      }
    },
    start () {
      return (this.page * this.count) + ((this.advisees.length > 0) ? 1 : 0)
    },
    end () {
      return (this.page * this.count) + this.advisees.length
    },
    showStudentPopover () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showStudentPopover') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    redirectStreamToProgressView () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'redirectStreamToProgressView') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isAutomaticStreamShareTurnedOn () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'automaticStreamShare') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isLockStreamEnabled () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (!advisorDashboardFeature || !advisorDashboardFeature.enabled) {
        return false
      }
      let lockStreamFlag = PackageUtil.getFlagFromFeature(advisorDashboardFeature, this.lockStreamFlagName)
      if (!lockStreamFlag) {
        return false
      }
      return lockStreamFlag.enabled || lockStreamFlag.isEnabled
    },
    isShowStudentEmail () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showStudentEmail') {
            return flags[i].enabled
          }
        }
      }
      return false
    },

    customAdvisorUnlockFeature () {
      if(!this.isCustomAdvisor()){
          return false
      }
      let customAdvisorFeature = this.customAdvisorFeature
      if (customAdvisorFeature) {
        let flags = customAdvisorFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Allow Unlock Course') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    customAdvisorWaiveFeature () {
      if(!this.isCustomAdvisor()){
          return false
      }
      let customAdvisorFeature = this.customAdvisorFeature
      if (customAdvisorFeature) {
        let flags = customAdvisorFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Allow Waive Course') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    customAdvisorUnenrollFeature () {
      if(!this.isCustomAdvisor()){
          return false
      }
      let customAdvisorFeature = this.customAdvisorFeature
      if (customAdvisorFeature) {
        let flags = customAdvisorFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Allow Unenroll') {
            return flags[i].enabled
          }
        }
      }
      return false
    },

    allowViewCourseReport () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'Allow View Course Report') {
            return flags[i].enabled
          }
        }
      }
      return false
    },

    isShowStudentExternalId () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showStudentExternalId') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowNamedQueryInformation () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showNamedQueryInformation') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowProgramName () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showProgramNameWithLabel') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    majorLabel () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showProgramNameWithLabel') {
            return flags[i].label
          }
        }
      }
      return 'Program'
    },
    isShowCareerInterest () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCareerInterestWithLabel') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    careerLabel () {
      let advisorDashboardFeature = this.advisorDashboardFeature
      if (advisorDashboardFeature) {
        let flags = advisorDashboardFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCareerInterestWithLabel') {
            return flags[i].label
          }
        }
      }
      return 'Career Interest'
    },
    isInstructorDashboard () {
      return (this.$route.name === 'instructorDashboard')
    }
  },

  watch: {
    searchQuery (newSearchQuery) {
      this.computeGroupToShow()
    },
    selectedTags (newSeletedTags) {
      this.computeGroupToShow()
    },
    currentGroup (newCurrentGroup) {
      this.computeGroupToShow()
    },
    selectedUserUuids (newValues) {
      let unreadCount = 0
      if(this.selectedUserUuids.length>0){
        this.selectedItemMessage = this.selectedUserUuids.length + ' of ' +this.groupToShow.length+ ' selected'
      } else {
        this.selectedItemMessage = ''
      }
      let userUuids = _.map(this.selectedUserUuids, 'userUuid')
      if (userUuids.length > 0) {
        userUuids.forEach(userId => {
          let ref = 'action-menu-' + userId
          if (this.$refs[ref] && this.$refs[ref].length > 0) {
            unreadCount += this.$refs[ref][0].$refs['channelActionMenu'].unreadCount
          }
        })
      }

      // this.$refs['group-action-menu'].$refs['channelActionMenu'].unreadCount = unreadCount
      // wait for DOM + guard ref existence
      this.$nextTick(() => {
        const groupMenu = this.$refs['group-action-menu']
        if (groupMenu && groupMenu.$refs.channelActionMenu) {
          groupMenu.$refs.channelActionMenu.unreadCount = unreadCount
        }
      })

    }
  }
}
</script>

<style lang="scss"
  src="../../../assets/module/sass/adviseeTracker/adviseeDetails.scss">
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/AdviseeTracker.vue